import { render } from "./InitialGame.vue?vue&type=template&id=56dd9472&scoped=true"
import script from "./InitialGame.vue?vue&type=script&lang=js"
export * from "./InitialGame.vue?vue&type=script&lang=js"

import "./InitialGame.vue?vue&type=style&index=0&id=56dd9472&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56dd9472"

export default script